import React, { useState, useEffect } from "react";
import "./backgroundStyles.css";

const opciones = [
  { id: "white",          nombre: "White",           clase: "bg-white"           },
  { id: "sunsetPink",     nombre: "Sunset Pink",     clase: "bg-sunset-pink"     },
  { id: "sunsetblue",     nombre: "Sunset blue",     clase: "bg-sunset-blue"     },
  { id: "sunset",         nombre: "Sunset Pastel",   clase: "bg-sunset"          },
  { id: "sunsetPeach",    nombre: "Sunset Peach",    clase: "bg-sunset-peach"    },
  { id: "sunsetSky",      nombre: "Sunset Sky",      clase: "bg-sunset-sky"      },
  { id: "sunsetLavender", nombre: "Sunset Lavender", clase: "bg-sunset-lavender" },
  { id: "sunsetTropical", nombre: "Sunset Tropical", clase: "bg-sunset-tropical" },
  { id: "crystal",        nombre: "Crystal Prism",   clase: "bg-crystal"         },
  { id: "roseQuartz",     nombre: "Rose Quartz",     clase: "bg-rose-quartz"     },
  { id: "nordic",         nombre: "Nordic Fog",      clase: "bg-nordic"          },
  { id: "citrus",         nombre: "Citrus Fresh",    clase: "bg-citrus"          },
  { id: "warmHaze",       nombre: "Warm Haze",       clase: "bg-warm-haze"       },
  { id: "glowGreen",      nombre: "Glow Green",      clase: "bg-glow-green"      },
  { id: "glowOrange",     nombre: "Glow Orange",     clase: "bg-glow-orange"     },
  { id: "mesh",           nombre: "Soft Mesh",       clase: "bg-mesh"            },
  { id: "electricViolet", nombre: "Electric Violet", clase: "bg-electric-violet" },
  { id: "tropicalStorm",  nombre: "Tropical Storm",  clase: "bg-tropical-storm"  },
  { id: "neonBlush",      nombre: "Neon Blush",      clase: "bg-neon-blush"      },
  { id: "deepOcean",      nombre: "Deep Ocean",      clase: "bg-deep-ocean"      },
  { id: "dots",           nombre: "Dots Premium",    clase: "bg-dots"            },
  { id: "stripe",         nombre: "Stripe Light",    clase: "bg-stripe"          },
  { id: "stripeOcean",    nombre: "Stripe Ocean",    clase: "bg-stripe-ocean"    },
  { id: "stripePink",     nombre: "Stripe Pink",     clase: "bg-stripe-pink"     },
  { id: "stripeMint",     nombre: "Stripe Mint",     clase: "bg-stripe-mint"     },
  { id: "stripeGold",     nombre: "Stripe Gold",     clase: "bg-stripe-gold"     },
  { id: "aurora",         nombre: "Aurora Light",    clase: "bg-aurora"          },
  { id: "grid",           nombre: "Modern Grid",     clase: "bg-grid"            },
  { id: "glow",           nombre: "Glow Light",      clase: "bg-glow"            },
];

const INICIAL = 4;

const ChevronIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M2.5 4.5L6.5 8.5L10.5 4.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Traducciones
const textos = {
  es: {
    verMas: "Ver más estilos",
    restantes: "restantes",
    verMenos: "Ver menos"
  },
  en: {
    verMas: "Show more styles",
    restantes: "remaining",
    verMenos: "Show less"
  }
};

export default function SelectBackground({
  value = "bg-white",
  onChange = () => {},
  language = "en",           // ← Nuevo parámetro
}) {
  const [seleccionado, setSeleccionado] = useState(value);
  const [expandido, setExpandido] = useState(false);

  useEffect(() => {
    setSeleccionado(value);
  }, [value]);

  const seleccionar = (item) => {
    setSeleccionado(item.clase);
    onChange({ id: item.id, clase: item.clase, nombre: item.nombre });
  };

  const visibles = expandido ? opciones : opciones.slice(0, INICIAL);
  const restante = opciones.length - INICIAL;

  const t = textos[language] || textos.en; // fallback a inglés si el idioma no existe

  return (
    <div>
      <div className="bg-selector-grid">
        {visibles.map((item) => (
          <div
            key={item.id}
            className={`bg-selector-card ${item.clase} ${
              seleccionado === item.clase ? "active" : ""
            }`}
            onClick={() => seleccionar(item)}
            title={item.nombre}
          >
            <div className="bg-selector-overlay">
              <span>{item.nombre}</span>
            </div>
          </div>
        ))}
      </div>

      <button
        className={`bg-selector-expand-btn${expandido ? " expanded" : ""}`}
        onClick={() => setExpandido(!expandido)}
      >
        <ChevronIcon />
        {expandido 
          ? t.verMenos 
          : `${t.verMas} · ${restante} ${t.restantes}`}
      </button>
    </div>
  );
}